import { forwardRef } from "react";
import Input, { InputProps } from "../Input/Input";

interface TextInputProps extends Omit<InputProps, "onChange"> {
  onChange?: (value: string) => void;
  allowClear?: boolean;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ onChange, allowClear = true, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        {...props}
        type="text"
        allowClear={allowClear}
        onChange={(value) => {
          if (onChange) {
            onChange(value);
          }
        }}
      />
    );
  },
);

export default TextInput;
